<template>
  <management-page :pageName="pageName" :menu="menu" class="management" />
</template>

<script>
import ManagementPage from "@/components/Management/Management";
import { managementViewMixin } from "@/mixins/management/managementViewMixin";
import ManagementSVG from "@/assets/management/management.svg";
export default {
  name: "BusinessIntelligencePage",

  components: { ManagementPage },

  mixins: [managementViewMixin],

  computed: {
    /**
     * Determine the page title
     * @returns {VueI18n.TranslateResult}
     */
    pageName() {
      return this.$i18n.t("BusinessIntelligence");
    },

    /**
     * Determines the menu available in the sidebar on the page
     * @returns {[{submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}]}
     */
    menu() {
      return [
        {
          name: this.$i18n.tc("Dashboard", 2),
          icon: ManagementSVG,
          disabled: !this.userHasManagementPermission("report_show"),
          submenu: [
            {
              name: this.$i18n.tc("Dashboard", 2),
              route: "dashboard",
              disabled: !this.userHasManagementPermission("report_show"),
              dev: false
            }
          ]
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/BusinessIntelligencePage.vue